import React from "react";
import { FileText } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "../../ui";
import { Textarea } from "../../ui/textarea";
import { DateField } from "../fields/DateField";

interface ProposalDetailsSectionProps {
 validUntil: string;
 deliveryDate: string;
 notes: string;
 onValidUntilChange: (isoDate: string) => void;
 onDeliveryDateChange: (isoDate: string) => void;
 onNotesChange: (notes: string) => void;
}

export const ProposalDetailsSection: React.FC<ProposalDetailsSectionProps> = ({
 validUntil,
 deliveryDate,
 notes,
 onValidUntilChange,
 onDeliveryDateChange,
 onNotesChange,
}) => {
 return (
 <Card>
 <CardHeader>
 <CardTitle className="flex items-center gap-2">
 <FileText className="h-5 w-5" />
 Detalhes da Proposta
 </CardTitle>
 </CardHeader>
 <CardContent className="space-y-4">
 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
 <div>
 <DateField
 label="Válido até"
 value={validUntil || ""}
 onChange={onValidUntilChange}
 placeholder="Selecione a data de validade"
 />
 </div>

 <div>
 <DateField
 label="Data de Entrega"
 value={deliveryDate || ""}
 onChange={onDeliveryDateChange}
 placeholder="Selecione a data de entrega"
 />
 </div>
 </div>

 <div>
 <label className="block text-sm font-medium text-foreground mb-2">
 Observações
 </label>
 <Textarea
 value={notes}
 onChange={(e) => onNotesChange(e.target.value)}
 placeholder="Observações sobre a proposta..."
 rows={3}
 />
 </div>
 </CardContent>
 </Card>
 );
};

